import { render, staticRenderFns } from "./nuevoAdapt.vue?vue&type=template&id=1a8719dd"
import script from "./nuevoAdapt.vue?vue&type=script&lang=js"
export * from "./nuevoAdapt.vue?vue&type=script&lang=js"
import style0 from "./nuevoAdapt.vue?vue&type=style&index=0&id=1a8719dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports